<template>
  <div class="verifyList">
    <div class="filter">
      <div class="searchContainer">
        <input v-model="searchText" placeholder="请输入关键词搜索..." type="text"/>
        <button @click="_initVerifyList"><i class="iconfont icon-ai219"></i></button>
      </div>
    </div>
    <div class="listContainer">
      <v-table
          :row-click-color="'rgba(239,239,239,0.5)'"
          :row-click="selectRow"
          style="width:100%"
          :is-horizontal-resize="true"
          :columns="columns"
          :table-data="tableData"
          :show-vertical-border="false"
          @on-custom-comp="onCustomHandle"
      ></v-table>
      <div class="pagination">
        <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="totalCount"
                      :pageIndex="pageIndex" :page-size="pageSize"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios/index';
  import apiConfig from 'common/js/api_config'
  //通信总线
  import Bus from 'common/js/bus.js';


  export default {
    name: "verifyList",
    data() {
      return {
        tableData: [],
        columns: [
          {
            field: 'id', title: '序号', width: 150, titleAlign: 'center', columnAlign: 'center',
            formatter: this.getRowNum,
            isFrozen: true, isResize: false
          },
          {
            field: 'username',
            title: '用户名',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'deptname',
            title: '部门',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
          },
          {
            field: 'title',
            title: '标题',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getPicReplaceText
          },
          {
            field: 'time',
            title: '发布时间',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getPicReplaceText
          },
          {
            field: 'sysName',
            title: '发布系统',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            formatter: this.getPicReplaceText
          },

          {
            field: 'detail',
            title: '查看详情',
            width: 100,
            titleAlign: 'center',
            columnAlign: 'center',
            isResize: true,
            componentName: 'notice-operation'
          },


        ],
        pageIndex: 1,
        pageSize: 10,
        pageCount: null,
        totalCount: null,
        searchText: null,

        //-----当前选择的Id-------
        currSelectId: null
      }
    },
    props: {
      preData: {
        type: Number
      }
    },
    computed: {},
    methods: {
      async _initVerifyList() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getAuthNoticeList?' + this.$qs.stringify({
          pageSize: this.pageSize,
          pageNumber: this.pageIndex,
          property: 'describe',
          keyword: this.searchText
        }))
        if (!resp.data.status) {
          return
        }
        let verifyListInfo = resp.data.data[0]
        this.tableData = verifyListInfo.list
        this.pageIndex = verifyListInfo.pageNumber
        this.pageSize = verifyListInfo.pageSize
        this.pageCount = verifyListInfo.pageCount
        this.totalCount = verifyListInfo.totalCount

      },
      selectRow(rowIndex, rowData, column) {
      },
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._initVerifyList()
      },
      pageSizeChange(newPageSize) {
        this.pageIndex = 1
        this.pageSize = newPageSize
        this._initVerifyList()
      },
      // //生成表格高亮标签
      // getLinkedText(rowData, rowIndex, pagingIndex, field) {
      //   return `<span class="highlightLink">${rowData[field]}</span>`;
      // },
      //图片特殊处理
      getPicReplaceText(rowData, rowIndex, pagingIndex, field) {
        if (rowData.columnName === 'zp') {
          return '[图片]'
        } else {
          return rowData[field]
        }
      },
      //生成表格高亮标签
      getLinkedButton(rowData, rowIndex, pagingIndex, field) {
        return `<button>处理审批</button>`;
      },

      //查看详情操作
      showVerifyDetail(id) {
        this.currSelectId = id

      },
      //审批处理操作
      async showVerifyHandle(item, type, reason) {
        let requestData = {}
        requestData.id = item.id
        requestData.state = type
        requestData.reason = reason ? reason : ''
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_updateNotice?' + this.$qs.stringify({
          id: requestData.id,
          state: requestData.state,
          reason: requestData.reason
        }))
        if (!resp.data.status) {
          return
        }
        this.currSelectId = null
        this._initVerifyList()
        this.$notify({
          group: 'global',
          title: '温馨提示',
          text: resp.data.msg
        })

      },
      //表格派发事件
      onCustomHandle(data) {
        let rowData = data.rowData
        switch (data.type) {
          case 'detail':
            this.$modal.show("noticeDetail", {data: rowData, url: undefined, title: rowData.title, auditPower: true});
            break
          case 'agree':
            this.showVerifyHandle(rowData, 1)
            break
          case 'reject':
            this.showVerifyHandle(rowData, 3)
            break
          default:
            console.log('onCustomHandle：type异常：' + data.type)
        }
      },
      setIdNull() {
        this.currSelectId = null
      },
      setItemAgree(ev) {
        this.showVerifyHandle(ev.item, 1, ev.reason)
      },
      setItemReject(ev) {
        this.showVerifyHandle(ev.item, 2, ev.reason)
      },
      //获取审核行号
      getRowNum(rowData, rowIndex, pagingIndex, field) {
        return this.pageSize * (this.pageIndex - 1) + (rowIndex + 1);
      }
    },
    destroyed() {
      this.currSelectId = null
    },
    components: {},
    mounted() {
      this.currSelectId = null
      if (this.preData >= 0) {
        this.currSelectId = this.preData
      }
      this._initVerifyList()

      Bus.$on('refresh', () => {
        this._initVerifyList()
      })
    }
  }

  // 自定义列组件
  Vue.component('notice-operation', {
    template: `<span class="operation-btnlist">
          <span class="btnlist" v-if="rowData.state===2">

            <button class="agree" href="" @click.stop.prevent="agree(rowData,index)">通过</button>
            <button class="reject" href="" @click.stop.prevent="reject(rowData,index)">驳回</button>
            <button class="detail" href="" @click.stop.prevent="detail(rowData,index)">内容预览</button>&nbsp;
          </span>
          <span class="btnlist">
            <span class="stateDesc agree" v-if="rowData.state===1">已通过</span>
            <span class="stateDesc disagree" v-if="rowData.state===3">已驳回</span>
            <button v-if="rowData.state!==2" class="detail" href="" @click.stop.prevent="detail(rowData,index)">内容预览</button>&nbsp;
          </span>


        </span>`,
    props: {
      rowData: {
        type: Object
      },
      field: {
        type: String
      },
      index: {
        type: Number
      }
    },
    methods: {
      detail() {
        // 参数根据业务场景随意构造
        let params = {type: 'detail', index: this.index, rowData: this.rowData};
        this.$emit('on-custom-comp', params);
      },
      agree() {
        // 参数根据业务场景随意构造
        let params = {type: 'agree', index: this.index, rowData: this.rowData};
        this.$emit('on-custom-comp', params);
      },
      reject() {
        // 参数根据业务场景随意构造
        let params = {type: 'reject', index: this.index, rowData: this.rowData};
        this.$emit('on-custom-comp', params);
      },

    }
  })

</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .verifyList
    .filter
      text-align right
      padding 20px

      .searchContainer
        display inline-block
        width 260px
        height 26px
        border-radius 13px
        border 1px solid #cccccc
        position relative
        font-size 14px
        line-height 26px
        color #666666
        overflow hidden
        text-align left

        & > input
          width 200px
          padding 0 15px

        & > button
          border none
          background #eeeeee
          outline none
          position absolute
          right 0
          top 0
          bottom 0
          width 40px
          line-height 26px

    .listContainer
      & >>> .operation-btnlist
        span
          font-size 14px

        .btnlist
          font-size 0

          .stateDesc
            margin-right 10px

            &.agree
              color #439138

            &.disagree
              color #5e1823

          & > button
            margin-right 5px
            color #ffffff
            font-size 14px
            border-radius 5px
            outline none
            background #eeeeee
            padding 2px 5px
            border none
            transition 300ms

            &.detail
              background #165986

              &:hover
                background #1A96D5

            &.agree
              background #439239

              &:hover
                background #58C94C

            &.reject
              background #ff6666

              &:hover
                background #A44646

</style>



// WEBPACK FOOTER //
// src/components/noticeVerify/verifyList.vue